import React, { useState } from 'react';
import { MenuItem } from 'react-bootstrap';
import axios from 'axios';

import routes from 'app/routes';

export default function AirtableSyncButton() {
  const sendReport = () => {
    axios
      .get(routes.api.enterprises.airtable_sync)
      .then((_resp) => {
        swal({
          title: '',
          text: 'Airtable will be updated soon. Please, open Airtable and check the update in a couple of minutes.',
        });
      });
  };

  return (
    <MenuItem
      onClick={sendReport}
    >
      Utilization Report
    </MenuItem>
  );
}
